/**
 * HTTP请求封装
 * 基于axios，预留统一的错误处理和拦截器配置
 */
import axios from 'axios';
import { BASE_API_URL, REQUEST_TIMEOUT } from './config';
// 创建axios实例
const request = axios.create({
    baseURL: BASE_API_URL,
    timeout: REQUEST_TIMEOUT
});
// 请求拦截器
request.interceptors.request.use((config) => {
    // 在这里可以添加认证token等
    // 比如从localStorage读取token添加到请求头
    const token = localStorage.getItem('token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    console.error('请求错误', error);
    return Promise.reject(error);
});
// 响应拦截器
request.interceptors.response.use((response) => {
    // 这里可以统一处理响应数据格式
    // 假设后端返回格式为 { code: number, data: T, message: string }
    const res = response.data;
    if (res.code !== 0) {
        // 统一错误处理
        console.error(res.message || '请求失败');
        // 可以在这里处理特定错误码，比如401未授权跳转登录
        return Promise.reject(res);
    }
    return res.data;
}, (error) => {
    console.error('响应错误', error);
    // 网络错误处理
    if (error.message.includes('timeout')) {
        console.error('请求超时，请检查网络连接');
    }
    else if (error.response) {
        console.error(`状态码: ${error.response.status}`);
    }
    return Promise.reject(error);
});
export default request;
